import { BACKGROUND_BEHIND } from "../../assets";
import { Judges } from "../../constants";
import LinkHead from "../../shared/components/LinkHead";
import { Footer } from "../../shared/Layouts/LandingPageLayout";

import Contact from "./contact";

import Hero from "./hero";
import LastestNews from "./lastestNews";
import Welcome from "./welcome";

function LandingPage() {
  return (
    <>
      <LinkHead title="Customary Court - Home" content="" />
      <Hero />
      <Welcome />
      <div className="py-8 sm:py-10 lg:py-12 xl:py-16 px-4 sm:px-8 lg:px-12 xl:px-16 2xl:px-20 3xl:px-24 flex justify-center flex-col gap-y-8 sm:gap-y-10 lg:gap-y-12 xl:gap-y-16 items-center max-w-[1920px] mx-auto">
        <span className="text-[14px] sm:text-[16px] lg:text-[18px] xl:text-[20px] text-center font-semibold text-globalGreen border-b-2 border-globalGreen pb-0.5">
          Our Judges
        </span>

        <div className="w-full grid grid-cols-1 mt-10 sm:grid-cols-2 lg:grid-cols-3  gap-x-6 sm:gap-8 lg:gap-6 gap-y-12 sm:gap-y-16 2xl:gap-y-36 lg:gap-y-44">
          {Judges.map((item, index) => (
            <div
              key={index}
              className="w-full max-h-[400px] xl:max-h-[450px] 2xl:max-h-[500px] flex flex-col relative items-center justify-center gap-y-3"
            >
              <div className="bg-[#F5F5F5] p-3 sm:p-5 lg:p-4 xl:p-6 rounded-lg w-full flex items-center justify-center">
                <img
                  src={item.image}
                  className="w-full min-h-[200px] sm:min-h-[250px] lg:min-h-[450px]  object-cover h-full z-30 rounded-md"
                  alt={`${item.name} - ${item.role}`}
                />
              </div>
              <img
                src={BACKGROUND_BEHIND}
                className="absolute w-full object-cover min-h-[200px] sm:min-h-[240px] lg:min-h-[260px] xl:min-h-[300px] 2xl:min-h-[320px] z-10 bottom-[3rem] sm:bottom-[4rem] lg:bottom-[4.5rem] xl:bottom-[6rem] 2xl:bottom-[1.7rem]"
                alt=""
              />

              <div className="flex flex-col justify-center gap-y-2 sm:gap-y-3 lg:gap-y-2 xl:gap-y-3 items-center mt-3 px-2">
                <span className="text-globalGreen text-xs sm:text-sm lg:text-sm xl:text-base font-semibold text-center">
                  {item.name}
                </span>
                <span className="text-xs sm:text-sm lg:text-sm xl:text-base font-medium text-gray-regular text-center leading-relaxed">
                  {item.role}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <LastestNews />
      <Contact />

      <Footer />
    </>
  );
}

export default LandingPage;
